/* ============================================================
   POKEALP · REFONTE 2026
   Fichier : assets/pokealp-refonte.js
   1. Header : état "scrollé" + hauteur réelle pour le hero
   2. Fiche produit : prix par carte sur les packs
   3. Fiche produit : rappel "booster offert" avec jauge live
   4. En-tête des avis Judge.me
   5. Cookies : une seule bannière (08/10/2026)
   v2 (08/10/2026) : montants dans la devise active (Shopify Markets).
   Seuil booster : montant rond par devise (window.paGift.thresholds),
   sinon conversion arrondie au multiple de 5 supérieur.
   ============================================================ */
(function () {
  'use strict';

  var html = document.documentElement;
  var cfg = window.paGift || { threshold: 10000, img: '' };

  /* ---------- 1. HEADER ---------- */
  function onScroll() {
    html.classList.toggle('pa-scrolled', (window.scrollY || html.scrollTop) > 12);
  }

  function measureHead() {
    if (!document.body.classList.contains('hdt-page-type-index')) return;
    var first = document.querySelector('#MainContent > .shopify-section:first-child');
    if (!first || !first.querySelector('.hdt-slideshow, .section-allow-transparent, [class*="slideshow"], [class*="hero"]')) {
      document.body.classList.add('pa-hero-off');
      return;
    }
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) {
      var cs = getComputedStyle(s);
      if (cs.display !== 'none' && cs.position !== 'fixed') h += s.offsetHeight;
    });
    if (h > 0) html.style.setProperty('--pa-head-h', h + 'px');
  }

  /* ---------- helpers ---------- */
  function parseMoney(txt) {
    if (!txt) return NaN;
    var m = String(txt).replace(/\s|&nbsp;/g, '').replace(/[’']/g, '').match(/(\d+(?:[.,]\d{1,2})?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : NaN;
  }
  function priceOf(el) {
    if (!el) return NaN;
    var c = el.getAttribute('data-cents');
    if (c !== null && c !== '' && !isNaN(parseInt(c, 10))) return parseInt(c, 10) / 100;
    return parseMoney(el.textContent);
  }
  function activeCurrency() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF'; } catch (e) { return 'CHF'; }
  }
  function marketRate() {
    var r = NaN;
    try { r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate); } catch (e) {}
    return r > 0 ? r : 1;
  }
  function fmt(n, round) {
    var cur = activeCurrency();
    if (cur === 'CHF') return 'CHF ' + (round ? String(Math.ceil(n)) : n.toFixed(2));
    try {
      var o = { style: 'currency', currency: cur };
      if (round) { o.minimumFractionDigits = 0; o.maximumFractionDigits = 0; n = Math.ceil(n); }
      return new Intl.NumberFormat(html.lang || 'fr', o).format(n);
    } catch (e) {
      return (round ? String(Math.ceil(n)) : n.toFixed(2)) + ' ' + cur;
    }
  }
  // Seuil booster dans la devise active : montant rond fixe si défini, sinon conversion arrondie à 5
  function giftThreshold() {
    var cur = activeCurrency();
    var fixed = cfg.thresholds && cfg.thresholds[cur];
    if (fixed) return fixed / 100;
    var base = (cfg.threshold || 10000) / 100;
    if (cur === 'CHF') return base;
    return Math.ceil((base * marketRate()) / 5) * 5;
  }

  /* ---------- 2. PRIX PAR CARTE ---------- */
  function addUnitPrices() {
    document.querySelectorAll('.hdt-product__variant-picker .pa-vp-inner').forEach(function (inner) {
      if (inner.querySelector('.pa-vp-unit')) return;
      var t = inner.querySelector('.pa-vp-title');
      var p = inner.querySelector('.pa-vp-price');
      if (!t || !p) return;
      var m = t.textContent.match(/(\d+)\s*x?\s*(cartes?|cards?|boosters?|packs?)/i);
      if (!m) return;
      var n = parseInt(m[1], 10);
      var price = priceOf(p);
      if (!n || n < 2 || isNaN(price)) return;
      var u = document.createElement('span');
      u.className = 'pa-vp-unit';
      var unitWord = /booster/i.test(m[2]) ? 'booster' : (/pack/i.test(m[2]) ? 'pack' : 'carte');
      u.textContent = fmt(price / n) + ' / ' + unitWord;
      inner.appendChild(u);
    });
  }

  /* ---------- 3. BOOSTER OFFERT ---------- */
  var cartTotal = 0;
  var giftEl = null;

  function currentLinePrice() {
    var info = document.querySelector('.hdt-product-info__list');
    if (!info) return 0;
    var checked = info.querySelector('.hdt-product__variant-picker input[is-value]:checked + label .pa-vp-price');
    var price = checked ? priceOf(checked) : NaN;
    if (isNaN(price)) {
      var priceEl = info.querySelector('.hdt-product__price hdt-price .hdt-money');
      price = priceEl ? parseMoney(priceEl.textContent) : 0;
    }
    var q = info.querySelector('.hdt-quantity__input');
    var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    return (price || 0) * qty;
  }

  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }

  function renderGift() {
    if (!giftEl) return;
    var threshold = giftThreshold();
    var line = currentLinePrice();
    var missing = Math.max(0, threshold - cartTotal);
    var pct = Math.min(100, (cartTotal / threshold) * 100);
    var title = giftEl.querySelector('.pa-gift__title');
    var sub = giftEl.querySelector('.pa-gift__sub');
    giftEl.classList.toggle('is-unlocked', missing <= 0);
    if (missing <= 0) {
      setText(title, 'Booster mystère offert');
      setText(sub, 'Ton panier atteint ' + fmt(threshold, true) + ', il sera glissé dans ta commande.');
    } else if (line >= missing) {
      setText(title, 'Ce produit te débloque le booster offert');
      setText(sub, 'Il te manque ' + fmt(missing) + ' : ajoute-le au panier et le booster mystère est à toi.');
    } else {
      setText(title, 'Booster offert dès ' + fmt(threshold, true) + ' de panier');
      setText(sub, 'Il te manque encore ' + fmt(missing) + ' dans ton panier.');
    }
    giftEl.querySelector('.pa-gift__fill').style.width = pct + '%';
  }

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = (c.total_price || 0) / 100; renderGift(); })
      .catch(function () { renderGift(); });
  }

  function mountGift() {
    var buy = document.querySelector('.hdt-product-info__list .hdt-product__buy-button');
    if (!buy || buy.querySelector('.pa-gift')) return;
    if (!buy.querySelector('.pokealp-btn--primary:not(:disabled)')) return;
    giftEl = document.createElement('div');
    giftEl.className = 'pa-gift';
    giftEl.setAttribute('aria-live', 'polite');
    giftEl.innerHTML =
      (cfg.img ? '<img class="pa-gift__img" src="' + cfg.img + '" alt="" width="34" height="46" loading="lazy">' : '') +
      '<div class="pa-gift__txt"><span class="pa-gift__title"></span><span class="pa-gift__sub"></span></div>' +
      '<div class="pa-gift__bar" aria-hidden="true"><span class="pa-gift__fill"></span></div>';
    buy.appendChild(giftEl);
    renderGift();
    fetchCart();

    var info = document.querySelector('.hdt-product-info__list');
    info.addEventListener('input', function (e) { if (e.target.matches('.hdt-quantity__input')) renderGift(); });
    info.addEventListener('change', function () { setTimeout(renderGift, 350); });
    info.addEventListener('click', function (e) {
      if (e.target.closest('.hdt-quantity__button')) setTimeout(renderGift, 60);
    });
    document.addEventListener('submit', function (e) {
      if (e.target.matches('form[action*="/cart/add"]')) setTimeout(fetchCart, 1200);
    }, true);
    watchCartRequests();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) fetchCart(); });
    window.addEventListener('pageshow', fetchCart);
  }

  var cartWatched = false;
  function watchCartRequests() {
    if (cartWatched || !window.fetch) return;
    cartWatched = true;
    var t;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { clearTimeout(t); t = setTimeout(fetchCart, 250); }, function () {});
      }
      return p;
    };
  }

  /* ---------- 4. EN-TÊTE DES AVIS JUDGE.ME ---------- */
  function reviewsHead() {
    var w = document.getElementById('judgeme_product_reviews');
    if (!w || w.closest('.pa-rv-card')) return;
    var avg = parseFloat(w.getAttribute('data-shop-average-rating'));
    var count = parseInt(w.getAttribute('data-shop-review-count'), 10);
    var head = document.createElement('div');
    head.className = 'pa-rv-head';
    var shop = '';
    if (avg && count) {
      shop = '<span class="pa-rv-head__shop"><span class="pa-rv-head__stars" aria-hidden="true">★★★★★</span>' +
        '<strong>' + avg.toFixed(1) + '</strong><span>/5 · ' + count + ' avis sur la boutique</span></span>';
    }
    head.innerHTML = '<div><span class="pa-rv-head__eyebrow">Avis clients</span><h2 class="pa-rv-head__title">Ce qu’ils en pensent</h2></div>' + shop;
    var card = document.createElement('div');
    card.className = 'pa-rv-card';
    w.parentNode.insertBefore(card, w);
    card.appendChild(head);
    card.appendChild(w);
  }

  /* ---------- 5. COOKIES : UNE SEULE BANNIÈRE ---------- */
  var ckYielded = false;
  function nativeBanner() {
    var n = document.getElementById('shopify-pc__banner') || document.querySelector('[id^="shopify-pc__banner"]');
    if (!n) return false;
    var cs = getComputedStyle(n);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && n.getBoundingClientRect().height > 0;
  }
  function consentGiven() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      return !!(cp && typeof cp.getTrackingConsent === 'function' && cp.getTrackingConsent() !== 'no_interaction');
    } catch (e) { return false; }
  }
  function syncCookies() {
    var c = document.querySelector('.pa-ck');
    if (!c) return;
    if (!ckYielded && (nativeBanner() || consentGiven())) ckYielded = true;
    if (ckYielded) {
      c.classList.remove('cookies-show');
      c.classList.add('pa-ck--yield');
    }
  }
  function initCookies() {
    if (!document.querySelector('.pa-ck')) return;
    var st = document.createElement('style');
    st.textContent = '.pa-ck.pa-ck--yield{display:none!important}';
    document.head.appendChild(st);
    syncCookies();
    document.addEventListener('visitorConsentCollected', syncCookies);
    if ('MutationObserver' in window) {
      var t;
      var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(syncCookies, 50); });
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }
    [300, 1000, 2500, 5000].forEach(function (d) { setTimeout(syncCookies, d); });
  }

  /* ---------- init ---------- */
  function init() {
    onScroll();
    measureHead();
    try { initCookies(); } catch (e) {}
    try { addUnitPrices(); } catch (e) {}
    try { mountGift(); } catch (e) {}
    try { reviewsHead(); } catch (e) {}
    setTimeout(function () { try { reviewsHead(); } catch (e) {} }, 2500);

    var picker = document.querySelector('.hdt-product-info__list');
    if (picker && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          try { addUnitPrices(); } catch (e) {}
          try { mountGift(); renderGift(); } catch (e) {}
        }, 120);
      }).observe(picker, { childList: true, subtree: true });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measureHead);
  window.addEventListener('load', measureHead);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();